<div nz-row [nzJustify]="justify" class="align-centered full-height always-centered">

	<nz-radio-group [ngModel]="selectedValueAsString" (ngModelChange)="select($event)" *ngIf="!isMultipleSelection">
		<label *ngFor="let entry of entries; index as i"
				nz-radio-button [nzValue]="''+entry?.choice?.value"
				[ngClass]="{
					'checked': entry?.selected,
					'unchecked': !entry?.selected && !finishedAndLocked,
					'large-button-single-select': isWizard,
					'table-display': isTableDisplay
				}"
				[attr.data-choice]="i" [nzDisabled]="finishedAndLocked || entry.deactivated || isLocked">
			{{entry?.choice?.text}}
		</label>
	</nz-radio-group>

	<nz-button-group *ngIf="isMultipleSelection" [className]="validClass">
		<button nz-button *ngFor="let entry of entries; index as i" (click)="toggle(entry)"
				[ngClass]="{
					'checked': entry?.selected,
					'unchecked': !entry?.selected && !finishedAndLocked,
					'large-button-multi-select': isWizard,
					'table-display': isTableDisplay
				}"
				[attr.data-choice]="i" (mouseout)="$event.target.blur()" [disabled]="finishedAndLocked || entry.deactivated || isLocked">
			{{entry?.choice?.text}}
		</button>
	</nz-button-group>

</div>
